<template>
  <div class="div-dialog" v-if="showAll">
    <div class="div-bg"></div>
    <div class="div-content">
      <div class="dialog-title">
        <div class="title-block">
          <img src="@/assets/images/questionBank/img(23).png" class="block-icon" alt="" />
          已答题
        </div>
        <div class="title-block">
          <div class="block-icon title-icon"></div>
          <!-- <img src="@/assets/images/questionBank/img(25).png" class="block-icon" alt=""> -->
          未答题
        </div>
        <img src="@/assets/images/questionBank/no-passed-close-btn.png" @click="closeDialog" class="close-img" alt="" />
      </div>
      <div class="flex-list">
        <div class="items-btn" v-for="(item, index) in topicList" :class="isAnswered(item) ? 'cur' : ''"
          :key="index" @click="handleClickTopic(index)">
          {{ index + 1 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionDialog',
  props: {
    showAll: {
      type: Boolean,
      required: true
    },
    topicList: {
      type: Array,
      required: true
    },
    showDraftAnswers: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isAnswered (item) {
      return `${item.answerStatus}` !== '2' || (this.showDraftAnswers && item.pickedIds && item.pickedIds.length > 0)
    },
    closeDialog () {
      this.$emit('update:showAll', false)
    },
    handleClickTopic (index) {
      this.$emit('topic-click', index)
    }
  }
}
</script>

<style lang="less" scoped>
.div-dialog {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 1px 4px 11px rgba(0, 0, 0, 0.25);
  border-radius: 24px 24px 0 0;
  z-index: 9;

  .dialog-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.3);
    height: 20px;
    padding: 0 25px;
    padding-top: 20px;
    padding-bottom: 16px;
    position: relative;

    .title-block {
      display: flex;
      align-items: center;
    }

    .close-img {
      width: 12px;
      height: 12px;
      position: absolute;
      top: 24px;
      right: 30px;
    }

    .block-icon {
      width: 16px;
      height: 16px;
      margin: 0 8px;

      &.title-icon {
        background-color: rgba(0, 0, 0, 0.08);
        border-radius: 50%;
      }
    }
  }

  .flex-list {
    max-height: calc(56vh - 125px);
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    padding: 0 25px;
    box-sizing: border-box;

    .items-btn {
      width: 40px;
      height: 40px;
      margin-right: 17px;
      margin-bottom: 16px;
      background-color: rgba(24, 24, 24, 0.08);
      font-size: 16px;
      color: rgba(0, 0, 0, 0.3);
      font-weight: bold;
      text-align: center;
      line-height: 40px;
      border-radius: 50%;

      &:nth-child(6n) {
        margin-right: 0;
      }

      &.cur {
        background-color: #EB1700;
        color: #fff;
      }
    }
  }

  .dialog-btn {
    width: 355px;
    height: 40px;
    border-radius: 100px;
    background-color: #EB1700;
    position: absolute;
    left: 10px;
    bottom: 15px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questionCom/indexComponents.vue